// Das Tor im Client (task-013, ADR 0027). Ob es offen ist, sagt der Server im `FarmState`; der
// Client setzt daraufhin den Torblock – `tor` ist fest, `tor_offen` nicht – und zeichnet die
// betroffenen Chunks neu. Weil der Block in der Welt des Clients liegt, lässt die eigene Physik
// den Avatar durch das offene Tor und hält ihn am geschlossenen auf; eine zweite Regel dafür gibt
// es nicht.
//
// Reine Logik ohne DOM und ohne Three.js.
import { BLOCK, CHUNK_SIZE, getBlock, setBlock, type Parcel, type World } from '@bauernhof/shared';

/** Setzt den Torblock einer Parzelle auf offen oder zu. Liefert, ob sich dabei etwas geändert hat. */
export function setzeTor(world: World, parcel: Parcel, offen: boolean): boolean {
  const { x, y, z } = parcel.gate;
  const soll = offen ? BLOCK.tor_offen : BLOCK.tor;
  if (getBlock(world, x, y, z) === soll) return false;
  setBlock(world, x, y, z, soll);
  return true;
}

/**
 * Die Chunks, deren Mesh ein geänderter Block berührt: sein eigener und, wenn er am Rand liegt,
 * der Nachbar auf dieser Seite – dort hängen Zaunarme und verdeckte Flächen an ihm. Schräge
 * Nachbarn nicht; Zäune verbinden sich nur in vier Richtungen. Nur Chunks innerhalb der Welt.
 */
export function chunksUmBlock(world: World, x: number, z: number): { cx: number; cz: number }[] {
  const cx = Math.floor(x / CHUNK_SIZE);
  const cz = Math.floor(z / CHUNK_SIZE);
  const inDerWelt = (a: number, b: number): boolean => a >= 0 && b >= 0 && a < world.chunksX && b < world.chunksZ;
  if (!inDerWelt(cx, cz)) return [];

  const liste = [{ cx, cz }];
  const lx = x - cx * CHUNK_SIZE;
  const lz = z - cz * CHUNK_SIZE;
  const nimm = (a: number, b: number): void => {
    if (inDerWelt(a, b)) liste.push({ cx: a, cz: b });
  };
  if (lx === 0) nimm(cx - 1, cz);
  if (lx === CHUNK_SIZE - 1) nimm(cx + 1, cz);
  if (lz === 0) nimm(cx, cz - 1);
  if (lz === CHUNK_SIZE - 1) nimm(cx, cz + 1);
  return liste;
}
